import { useAccount } from '@/routes/_authenticated/_dashboard/accounts/$accountId/route.hooks';
import { type NonEmptyArray } from '@/utils/types';

/**
 * Checks whether the current account holds the given privileges. Privileges are account-level flags
 * (e.g. `PREMIUM_TIER`, `HYBRID_CLOUD`), not RPC permissions — for those use `useRpcPermissions`.
 */
export function usePrivilegeAccessControl(requiredPrivileges: NonEmptyArray<string>): {
  matches: boolean;
  missingPrivileges: string[];
} {
  const { privileges } = useAccount();
  const missingPrivileges = requiredPrivileges.filter((p) => !privileges.includes(p));

  return { matches: missingPrivileges.length === 0, missingPrivileges };
}
